import { renderRcdIcons } from "../icons";

const MAX_DIGITS = 15;

const sanitizePhoneInput = (raw, cursor) => {
    let value = "";
    let newCursor = 0;
    let digitCount = 0;

    for (let i = 0; i < raw.length; i += 1) {
        const char = raw[i];
        let keep = false;

        if (char === "+" && value.length === 0) {
            keep = true;
        } else if (/\d/.test(char) && digitCount < MAX_DIGITS) {
            keep = true;
            digitCount += 1;
        }

        if (keep) {
            value += char;
        }
        if (i < cursor && keep) {
            newCursor += 1;
        }
    }

    return { value, cursor: newCursor };
};

const wrapPhoneInput = (input) => {
    // A span is also matched by the shared `.rcd-field > span` label rule,
    // which splits the icon and input into separate rows. A neutral flow
    // container keeps this enhancer safe in every form that uses it.
    const wrapper = document.createElement("div");
    wrapper.className = "rcd-phone-field";
    input.replaceWith(wrapper);
    wrapper.innerHTML = '<i data-lucide="phone" aria-hidden="true"></i>';
    wrapper.append(input);
};

export const setupRcdPhoneInputs = (root = document) => {
    const inputs = root.querySelectorAll("[data-phone-input]:not([data-phone-input-ready])");
    if (inputs.length === 0) {
        return;
    }

    inputs.forEach((input) => {
        input.dataset.phoneInputReady = "true";
        if (input.type === "text") {
            input.type = "tel";
        }
        input.inputMode = "tel";
        if (!input.autocomplete) {
            input.autocomplete = "tel";
        }

        wrapPhoneInput(input);

        const { value: cleaned } = sanitizePhoneInput(input.value, input.value.length);
        if (cleaned !== input.value) {
            input.value = cleaned;
        }

        input.addEventListener("input", () => {
            const cursor = input.selectionStart ?? input.value.length;
            const { value, cursor: nextCursor } = sanitizePhoneInput(input.value, cursor);
            if (value !== input.value) {
                input.value = value;
                input.setSelectionRange(nextCursor, nextCursor);
                input.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    });

    renderRcdIcons();
};
